// extracted by mini-css-extract-plugin
export default {"search-icon":"sort-icon_search-icon__nuohN","search-icon-active":"sort-icon_search-icon-active__gpdnN"};